import i18n from "config/i18next";

i18n.addResources("es", "Home", {
  dashboard: "Monitor",
  polygons: "Polígonos",
  transactions: "Transacciones",
  title: "¿Qué operación querés realizar?",
});
